import type { RudderstackEventData, RudderstackEventNames } from "@/types/rudderstack";
import { ADMIN_USERS_TRACKING_EVENTS } from "./admin/users";

// Helper type to get the properties type for a specific event
type EventProperties<TEventName extends RudderstackEventNames> = Omit<RudderstackEventData[TEventName], "success">;

type TrackingEventConfig<TEventName extends RudderstackEventNames> = {
  event: TEventName;
  properties?: (variables: any) => EventProperties<TEventName>;
};

// Helper function to create tracking configs with better type inference
export function createTrackingConfig<TEventName extends RudderstackEventNames>(
  event: TEventName,
  properties?: (variables: any) => EventProperties<TEventName>,
): TrackingEventConfig<TEventName> {
  return { event, properties };
}

// Main tracking events configuration object
export const TRACKING_EVENTS = {
  admin: {
    users: ADMIN_USERS_TRACKING_EVENTS,
  },
} as const;

export function getTrackingConfig<TEventName extends RudderstackEventNames>(
  category: keyof typeof TRACKING_EVENTS,
  subcategory: string,
  action: string,
): TrackingEventConfig<TEventName> | undefined {
  const categoryEvents = TRACKING_EVENTS[category];
  const subcategoryEvents = (categoryEvents as Record<string, any>)[subcategory];

  if (!subcategoryEvents) {
    return undefined;
  }

  const actionEvents = (subcategoryEvents as Record<string, any>)[action];

  if (!actionEvents) {
    return undefined;
  }

  return actionEvents as TrackingEventConfig<TEventName>;
}

export type { TrackingEventConfig };
